(function() {
    'use strict';

    angular
        .module('elogbooks.admin.core-clients')
        .controller('CoreClientsMarkupController', CoreClientsMarkupController);

    CoreClientsMarkupController.$inject = [
        'coreClientMarkupCollectionResponse',
        '$stateParams',
        '$state',
        'modulesService'
    ];
    function CoreClientsMarkupController(
        coreClientMarkupCollectionResponse,
        $stateParams,
        $state,
        modulesService
    ) {
        var vm = this;
        vm.coreClientMarkupCollectionResponse = coreClientMarkupCollectionResponse;
        vm.coreClientsMarkup = coreClientMarkupCollectionResponse.coreclientsmarkup;
        vm.order = orderAction;
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');

        function orderAction(key) {
            $stateParams.markupOrder = key;
            $state.go('.', angular.extend({}, $stateParams), { reload: $state.current });
        }        
    }
})();
